// 📁 src/pages/PoolStatsPage.jsx
import React, { useEffect, useState } from "react";
import { Table } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "../styles/TableStyles.css";

export default function PoolStatsPage() {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await fetch("/api/pool/LEMON/stats", {
          method: "GET",
          credentials: "include"
        });
        if (!res.ok) throw new Error("Nepodařilo se načíst pool statistiky");
        const json = await res.json();
        setStats(json);
      } catch (err) {
        console.error("Chyba API:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  return (
    <div className="table-container">
      <h2>Statistiky POOLu</h2>

      {loading ? (
        <p>Načítám data…</p>
      ) : (
        <Table className="custom-table">
          <thead>
            <tr>
              <th>Pobočka</th>
              <th>Ohroženci – počet</th>
              <th>Ohroženci – suma NCSD</th>
              <th>Ležáci – počet</th>
              <th>Ležáci – suma NCSD</th>
              <th>Suma skladu</th>
            </tr>
          </thead>

          <tbody>
            {stats.map((s, i) => (
              <tr key={i}>
                <td>{s.pobocka}</td>

                {/* OHROŽENCI */}
                <td>{s.ohrozenciCount}</td>
                <td>
                  {s.ohrozenciSum
                    ? `${s.ohrozenciSum.toLocaleString("cs-CZ")} Kč`
                    : "0 Kč"
                  }
                  {" "}
                  ({String(s.percentOhrozenci).replace(".", ",")} %)
                </td>


                {/* LEŽÁCI */}
                <td>{s.lezaciCount}</td>
                <td>
                  {s.lezaciSum
                    ? `${s.lezaciSum.toLocaleString("cs-CZ")} Kč`
                    : "0 Kč"
                  }
                  {" "}
                  ({String(s.percentLezaci).replace(".", ",")} %)
                </td>

                <td>{s.totalSum.toLocaleString("cs-CZ")} Kč</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
}
